import type { ElementType, PropsWithChildren } from "react";

import type { StatusBadgeVariantProps } from "~/components/StatusBadge/statusBadgeVariants.ts";
import { statusBadgeVariants } from "~/components/StatusBadge/statusBadgeVariants.ts";
import { ThemeName } from "~/utils/themeVariants.ts";

export type BaseStatusProps = StatusBadgeVariantProps & {
    as?: ElementType;
}

type StatusBadgeProps = BaseStatusProps & React.ButtonHTMLAttributes<HTMLButtonElement>;

const StatusBadge: React.FC<PropsWithChildren<StatusBadgeProps>> = ({
    borderRadius = 'default',
    children,
    theme = ThemeName.Neutral,
    size = 'default',
    as = 'div',
    ...rest
}) => {
    const Component: ElementType = as;

    return (
        <Component
            className={statusBadgeVariants({borderRadius, size, theme})}
            {...rest}
        >
            {children}
        </Component>
    );
};

export default StatusBadge;

